<template>
  <section class="invoice-add-wrapper">
    <b-row class="invoice-add">

      <!-- left information -->
      <b-col
        cols="12"
        xl="6"
      >
        <b-card class="p-lg-1 pb-lg-2">
          <h4 class="text-primary font-weight-bold">
            Data Pelanggan
          </h4>

          <b-row>
            <b-col
              cols="12"
              xl="12"
            >
              <!-- Select Client -->
              <v-select
                v-model="invoiceData.customer"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="customerOpt"
                disabled
                label="customer"
                :filterable="false"
                :loading="customerOptL"
                @search="customerOptS"
              >
                <template #list-header>
                  <li
                    v-b-toggle.sidebar-invoice-add-new-customer
                    class="add-new-client-header d-flex align-items-center my-50"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      size="16"
                    />
                    <span class="align-middle ml-25">Add New Customer</span>
                  </li>
                </template>
              </v-select>
            </b-col>
          </b-row>

          <div
            v-if="invoiceData.customer"
            class="mt-2 row"
          >
            <b-col
              cols="12"
              lg="6"
            >
              <b-form-group label="No Hp">
                <b-form-input
                  :value="invoiceData.customer.raw.phone"
                  class="form-control"
                  type="text"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              lg="6"
            >
              <b-form-group label="Saldo Deposit">
                <cleave
                  :value="invoiceData.customer.raw.depo_balance"
                  :raw="true"
                  readonly
                  class="form-control"
                  type="text"
                  :options="currencyOptions"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              lg="12"
            >
              <!-- Informasi Tambahan -->
              <b-card
                class="shadow-sm border mb-0"
                border-variant="primary"
              >
                <b-card-text class="mb-1">
                  <b>Informasi Tambahan :</b>
                </b-card-text>

                <ul class="list-unstyled mb-0">
                  <li>
                    <feather-icon
                      icon="MailIcon"
                      size="16"
                      class="mr-1 text-muted"
                    />
                    {{ invoiceData.customer.raw.email }}
                  </li>
                  <li class="mt-1 d-inline-flex align-items-center">
                    <feather-icon
                      icon="UserCheckIcon"
                      size="16"
                      class="mr-1 text-muted"
                    />
                    <b-form-checkbox
                      v-model="invoiceData.customer.raw.is_member"
                      :value="1"
                      :unchecked-value="0"
                      class="m-0"
                      @change="updateIsMember(invoiceData.customer.raw.is_member)"
                    />
                    <span class="mr-2">
                      {{ invoiceData.customer.raw.is_member ? 'Member' : 'Non Member' }}
                    </span>
                  </li>
                  <li>
                    <small class="text-muted">
                      (Centang untuk menjadikan pelanggan sebagai Member)
                    </small>
                  </li>

                </ul>
              </b-card>
            </b-col>
          </div>

        </b-card>
      </b-col>

      <!-- right information -->
      <b-col
        cols="12"
        xl="6"
      >
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="mb-1 p-md-0"
          >
            <b-card class="mb-0">
              <b-form-group
                label="1. Tipe Pengiriman"
                class="text-primary"
              >
                <v-select
                  v-model="invoiceData.shipping_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="shippingOpt"
                  label="shipping"
                  :clearable="true"
                />

                <b-button
                  v-b-modal.modal-shipping
                  variant="outline-info"
                  class="mt-1"
                >
                  Set Alamat
                </b-button>
              </b-form-group>

              <!-- modal shipping -->
              <b-modal
                id="modal-shipping"
                ok-only
                ok-title="Simpan"
                centered
                size="lg"
                title="Alamat Pengiriman"
              >
                <b-card-body>
                  <!-- Customer Name -->
                  <b-form-group
                    label="Nama Penerima"
                    label-for="customer-name"
                  >
                    <b-form-input
                      id="customer-name"
                      v-model="invoiceData.so_addresses.name"
                      trim
                      placeholder="Jhon Wiranto"
                    />
                  </b-form-group>

                  <!-- Phone -->
                  <b-form-group
                    label="No HP"
                    label-for="phone"
                  >
                    <b-form-input
                      id="contact"
                      v-model="invoiceData.so_addresses.phone"
                      type="number"
                      placeholder="081xxxxxxxxx"
                      trim
                    />
                  </b-form-group>

                  <!-- Email -->
                  <b-form-group
                    label="Email"
                    label-for="email"
                  >
                    <b-form-input
                      id="email"
                      v-model="invoiceData.so_addresses.email"
                      trim
                      placeholder="example@domain.com"
                      type="email"
                    />
                  </b-form-group>

                  <!-- Address -->
                  <b-form-group
                    label="Alamat Lengkap"
                    label-for="address"
                  >
                    <b-form-textarea
                      id="address"
                      v-model="invoiceData.so_addresses.address_line1"
                      placeholder="Contoh : Jalan Warujayeng"
                      trim
                    />
                  </b-form-group>

                  <!-- Provinsi -->
                  <b-form-group
                    label="Provinsi"
                    label-for="country"
                  >
                    <b-form-input
                      id="province"
                      v-model="invoiceData.so_addresses.province"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      type="text"
                      trim
                    />
                  </b-form-group>

                  <!-- City -->
                  <b-form-group
                    label="Kabupaten / Kota"
                    label-for="city"
                  >
                    <b-form-input
                      id="city"
                      v-model="invoiceData.so_addresses.city"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      type="text"
                      placeholder="Contoh : Kota Surabaya"
                      trim
                    />
                  </b-form-group>

                  <!-- subdistrict -->
                  <b-form-group
                    label="Kecamatan"
                    label-for="subdistrict"
                  >
                    <b-form-input
                      id="subdistrict"
                      v-model="invoiceData.so_addresses.subdistrict"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      type="text"
                      trim
                    />
                  </b-form-group>

                  <!-- village -->
                  <b-form-group
                    label="Kelurahan"
                    label-for="village"
                  >
                    <b-form-input
                      id="village"
                      v-model="invoiceData.so_addresses.village"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      type="text"
                      trim
                    />
                  </b-form-group>

                  <!-- postal code -->
                  <b-form-group
                    label="Kode Pos"
                    label-for="postal-code"
                  >
                    <b-form-input
                      id="postal-code"
                      v-model="invoiceData.so_addresses.postal_code"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      type="text"
                      trim
                    />
                  </b-form-group>
                </b-card-body>
              </b-modal>

            </b-card>
          </b-col>

          <b-col
            cols="12"
            md="6"
            class="mb-1 pl-1 pr-1"
          >
            <b-card class="mb-0 h-100">
              <div class="d-flex flex-column align-items-start">
                <small class="text-muted mb-1">Total Harga</small>
                <h1 class="text-success fw-bold">
                  Rp{{ new Intl.NumberFormat('id-ID').format(invoiceData.grand_total) }}
                </h1>
                <small class="text-muted">Termasuk pajak & biaya lainnya</small>
              </div>
            </b-card>
          </b-col>

        </b-row>
      </b-col>

      <!-- main table -->
      <b-col
        cols="12"
        xl="12"
      >
        <b-card>
          <b-card-body class="invoice-padding p-0 p-lg-2 form-item-section">
            <div
              class="invoice-spacing mt-0 mb-2 p-0"
            >
              <b-button
                v-b-modal.modal-item
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                variant="primary"
              >
                Tambah Item
              </b-button>

              <b-button
                v-b-modal.modal-add-on
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="ml-md-1 mt-1 mt-md-0"
                size="sm"
                variant="info"
              >
                Tambah Biaya
              </b-button>

              <b-button
                v-if="$can('sales', 'toko-cashier-add')"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="success"
                class="ml-md-1 mt-1 mt-md-0"
                size="sm"
                @click="handleSubmit()"
              >
                <feather-icon
                  icon="ShoppingCartIcon"
                  size="16"
                />
                Simpan Perubahan
              </b-button>

            </div>
            <!-- Invoice Description: Table -->
            <b-table-lite
              responsive
              :items="invoiceData.items"
              :fields="[
                { key: 'actions', label: 'Aksi' },
                { key: 'invoiceData', label: 'Produk' },
                { key: 'p', label: 'P' },
                { key: 'l', label: 'L' },
                { key: 'qty', label: 'Jumlah' },
                { key: 'price', label: 'Harga' },
                { key: 'discount', label: 'Diskon' },
                { key: 'subtotal', label: 'Total' },
              ]"
            >
              <template #cell(invoiceData)="data">
                <b-card-text class="font-weight-bold mb-25">
                  {{ data.item.itemTitle.product }}
                  <span
                    v-if="data.item.price==0"
                    class="text-danger"
                  >(Harga Tidak Ditemukan)</span>
                </b-card-text>
                <b-card-text class="text-nowrap">
                  {{ data.item.desc }}
                </b-card-text>
              </template>
              <template #cell(price)="data">
                <b-card-text class="font-weight-bold mb-25">
                  {{ data.item.price ? new Intl.NumberFormat('en-US').format(data.item.price) : '0' }}
                </b-card-text>
              </template>
              <template #cell(discount)="data">
                {{ data.item.price ? new Intl.NumberFormat('en-US').format(data.item.discount) : '0' }}
              </template>
              <template #cell(subtotal)="data">
                <b-card-text class="font-weight-bold mb-25">
                  {{ new Intl.NumberFormat('en-US').format(data.item.subtotal) }}
                </b-card-text>
              </template>
              <template #cell(actions)="data">
                <b-button
                  v-if="data.item.item != 'ADD999-ON'"
                  size="sm"
                  variant="outline-warning"
                  class="mr-1"
                  @click="editItem(data.item)"
                >
                  <feather-icon
                    icon="EditIcon"
                    size="16"
                  />
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-danger"
                  @click="deleteItem(data.index)"
                >
                  <feather-icon
                    icon="TrashIcon"
                    size="16"
                  />
                </b-button>
              </template>
            </b-table-lite>

            <!-- modal item -->
            <b-modal
              id="modal-item"
              ok-title="Tambah"
              centered
              size="lg"
              title="Tambah Item"
              @ok="addNewItemInItemForm"
            >
              <b-card-body>
                <b-button
                  v-b-modal.modal-price
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  size="sm"
                  variant="primary"
                  class="mb-2"
                >
                  Lihat Harga
                </b-button>
                <b-row>
                  <b-col
                    cols="12"
                    lg="7"
                  >
                    <b-form-group
                      label="Nama Produk"
                    >
                      <v-select
                        v-model="itemNew.itemTitle"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="itemsOptions"
                        label="product"
                        :clearable="false"
                        class="item-selector-title"
                        placeholder="Select Product"
                        @input="val => updateItemForm(val)"
                      />
                      <p>
                        <span
                          v-if="itemNew.price == 0"
                          class="text-danger"
                        >Harga tidak ditemukan untuk produk ini</span>
                      </p>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    lg="5"
                  >
                    <b-form-group
                      label="Harga"
                    >
                      <b-input-group>
                        <cleave
                          id="price"
                          v-model="itemNew.price"
                          :readonly="!itemNew.editable_price"
                          :raw="true"
                          class="form-control"
                          type="text"
                          placeholder="Masukkan Harga"
                          :options="currencyOptions"
                        />

                        <b-input-group-append>
                          <b-button
                            v-b-modal.modal-request-price
                            :variant="!itemNew.editable_price ? 'outline-secondary' : 'success'"
                            :style="{ 'border-radius': '0', 'border': '1px solid #d8d6de' }"
                          >
                            <feather-icon
                              :icon="!itemNew.editable_price ? 'LockIcon' : 'UnlockIcon'"
                              size="16"
                            />
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    lg="4"
                  >
                    <b-form-group
                      label="Qty"
                    >
                      <label class="d-inline d-lg-none">Qty</label>
                      <b-input-group>
                        <template #append>
                          <b-input-group-text><strong>{{ itemNew.unit }}</strong></b-input-group-text>
                        </template>
                        <b-form-input
                          v-model="itemNew.qty"
                          type="number"
                          @input="updateItemPriceQty()"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    lg="4"
                  >
                    <b-form-group
                      label="Panjang"
                    >
                      <b-form-input
                        v-model="itemNew.p"
                        type="number"
                        :readonly="!itemNew.is_dimension"
                        @input="updateItemPriceQty()"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    lg="4"
                  >
                    <b-form-group
                      label="Lebar"
                    >
                      <b-form-input
                        v-model="itemNew.l"
                        type="number"
                        :readonly="!itemNew.is_dimension"
                        @input="updateItemPriceQty()"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                  >
                    <b-form-group
                      label="Catatan"
                    >
                      <b-form-textarea
                        v-model="itemNew.note"
                        row="1"
                        class="mb-2 mb-lg-0"
                      />
                    </b-form-group>

                  </b-col>
                  <b-col
                    cols="12"
                    lg="6"
                  >
                    <b-form-group
                      label="Finishing"
                    >
                      <b-form-input
                        v-model="itemNew.finishing"
                        type="text"
                      />
                    </b-form-group>

                  </b-col>
                  <b-col
                    cols="12"
                    lg="6"
                  >
                    <b-form-group
                      label="File"
                    >
                      <b-form-input
                        v-model="itemNew.file"
                        type="text"
                      />
                    </b-form-group>

                  </b-col>
                  <b-col cols="6">
                    <b-form-group label="Diskon Item">
                      <cleave
                        id="discount"
                        v-model="itemNew.discount"
                        :raw="true"
                        class="form-control"
                        type="text"
                        placeholder="Masukkan Diskon Item"
                        :options="currencyOptions"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group label="SubTotal">
                      <b-form-input
                        :value="new Intl.NumberFormat('en-US').format(itemNew.p * itemNew.l * itemNew.qty * itemNew.price - itemNew.discount)"
                        type="text"
                        readonly
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-modal>

            <!-- modal add on -->
            <b-modal
              id="modal-add-on"
              ok-title="Tambah"
              centered
              size="lg"
              title="Tambah Biaya Lainnya"
              @ok="addNewAddOnInItemForm"
            >
              <b-card-body>
                <b-row>
                  <b-col
                    cols="12"
                    lg="12"
                  >
                    <b-form-group
                      label="Nama Biaya"
                    >
                      <b-form-input
                        v-model="addOn.name"
                        type="text"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    lg="6"
                  >
                    <b-form-group
                      label="Harga Pokok"
                    >
                      <b-input-group>
                        <cleave
                          id="cost_price"
                          v-model="addOn.cost_price"
                          :raw="true"
                          class="form-control"
                          type="text"
                          placeholder="Masukkan Harga Modal"
                          :options="currencyOptions"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    lg="6"
                  >
                    <b-form-group
                      label="Harga Jual"
                    >
                      <b-input-group>
                        <cleave
                          id="price"
                          v-model="addOn.price"
                          :raw="true"
                          class="form-control"
                          type="text"
                          placeholder="Masukkan Harga"
                          :options="currencyOptions"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                  >
                    <b-form-group
                      label="Keterangan"
                    >
                      <b-form-textarea
                        v-model="addOn.note"
                        row="1"
                        class="mb-2 mb-lg-0"
                      />
                    </b-form-group>

                  </b-col>
                </b-row>
              </b-card-body>
            </b-modal>

            <!-- modal price -->
            <b-modal
              id="modal-price"
              ok-only
              ok-title="Tutup"
              centered
              size="lg"
              title="Harga Produk"
            >
              <b-card-body>
                <b-table
                  responsive="sm"
                  :items="itemNew.prices"
                  :fields="[
                    { key: 'member_status', label: 'Status Member' },
                    { key: 'min_sales', label: 'Min Pembelian' },
                    { key: 'price', label: 'Harga' },
                  ]"
                >
                  <template #cell(member_status)="data">
                    {{ data.item.member_status == 1 ? 'Member' : 'Umum' }}
                  </template>
                  <template #cell(price)="data">
                    {{ formatCurrency(data.item.price) }}
                  </template>
                </b-table>
              </b-card-body>
            </b-modal>
            <!-- modal request price -->
            <b-modal
              id="modal-request-price"
              ok-title="Buka Harga"
              ok-variant="success"
              centered
              size="sm"
              title="Buka Akses Harga"
              @ok="handleEditAccess()"
            >
              <b-card-body>
                <b-form-group
                  label="Username"
                  label-for="request-username"
                >
                  <b-form-input
                    id="request-username"
                    v-model="editAccess.username"
                    type="text"
                    placeholder="Masukan Username"
                  />
                </b-form-group>
                <b-form-group
                  label="Password"
                  label-for="request-password"
                >
                  <b-form-input
                    id="request-password"
                    v-model="editAccess.password"
                    type="password"
                    placeholder="Masukan Password"
                  />
                </b-form-group>
              </b-card-body>
            </b-modal>
          </b-card-body>

          <!-- Invoice Description: Total -->
          <b-card-body class="invoice-padding pb-0">
            <b-row>

              <!-- Col: Sales Persion -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-0 mt-3 d-flex align-items-center"
                order="2"
                order-md="1"
              >
                <label
                  for="invoice-data-sales-person"
                  class="text-nowrap mr-50"
                >Nama PIC:</label>
                <b-form-input
                  id="invoice-data-sales-person"
                  v-model="invoiceData.salesPerson"
                  placeholder="Contoh : Eko Rahardjo"
                />
              </b-col>

              <!-- Col: Total -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-6 d-flex justify-content-end"
                order="1"
                order-md="2"
              >
                <div class="invoice-total-wrapper">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Total:
                    </p>
                    <p class="invoice-total-amount">
                      Rp{{ new Intl.NumberFormat('en-US').format(invoiceData.total) }}
                    </p>
                  </div>
                  <div class="invoice-total-item">
                    <span>Diskon:</span>
                    <cleave
                      id="discount-header"
                      v-model="invoiceData.disc_exp"
                      :raw="true"
                      type="text"
                      class="form-control mb-2 ml-1"
                      placeholder="Masukkan Diskon Item"
                      :options="currencyOptions"
                      @input="updateDiscountHeader()"
                    />
                  </div>
                  <hr class="my-50">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Total Tagihan:
                    </p>
                    <p class="invoice-total-amount">
                      Rp{{ new Intl.NumberFormat('en-US').format(invoiceData.grand_total) }}
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing">

          <!-- Note -->
          <b-card-body class="invoice-padding pt-0">
            <span class="font-weight-bold">Note: </span>
            <b-form-textarea v-model="invoiceData.description" />
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>
    <invoice-sidebar-add-new-customer
      :customer="customer"
      @submitCustomer="handleCustomerSubmit"
    />
  </section>
</template>

<script>
import { ref, getCurrentInstance, onUnmounted } from '@vue/composition-api'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import {
  BRow, BCol, BCard, BCardBody, BButton, BCardText, BFormGroup, BFormInput, BFormTextarea, VBToggle, BFormCheckbox, BTableLite,
  BInputGroup, BInputGroupText, BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import invoiceStoreModule from '../invoiceStoreModule'
import InvoiceSidebarAddNewCustomer from '../InvoiceSidebarAddNewCustomer.vue'

export default {
  components: {
    BTable,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BFormCheckbox,
    BButton,
    BCardText,
    BInputGroupText,
    BTableLite,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    vSelect,
    InvoiceSidebarAddNewCustomer,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,

  },
  mixins: [heightTransition],
  data() {
    return {
      currencyOptions: this.$currencyOptions.number,
      isEditMode: false,
      editIndex: null,
      editAccess: {
        username: null,
        password: null,
      },
    }
  },
  watch: {
    'invoiceData.customer.raw.is_member': {
      handler() {
        this.updateIsMember(this.invoiceData.customer.raw.is_member)
      },
      deep: true,
    },
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    formatCurrency(val) {
      return new Intl.NumberFormat('en-US').format(val || 0)
    },
    parseCurrency(str) {
      return Number(str.replace(/\D/g, '')) // hanya angka, hapus titik & simbol
    },
    editItem(item) {
      this.isEditMode = true
      // Misalnya buka modal dan isi data yang mau diedit
      this.itemNew = { ...item }
      this.$bvModal.show('modal-item')
    },
    deleteItem(index) {
      this.invoiceData.items.splice(index, 1)
      this.updateTotal()
    },
    addNewItemInItemForm() {
      this.itemNew.subtotal = this.itemNew.p * this.itemNew.l * this.itemNew.qty * this.itemNew.price - this.itemNew.discount
      if (this.isEditMode) {
        this.invoiceData.items.splice(this.editIndex, 1)
        this.editIndex = null
        this.isEditMode = false
        this.invoiceData.items.push(JSON.parse(JSON.stringify(this.itemNew)))
      } else {
        this.invoiceData.items.push(JSON.parse(JSON.stringify(this.itemNew)))
      }
      this.itemNew = {
        item: null,
        price: 0,
        prices: [],
        subtotal: 0,
        qty: 0,
        discount: 0,
        unit: 'PCS',
        finishing: '',
        file: '',
        note: '',
        p: 1,
        l: 1,
        editable_price: false,
        is_stock: true,
      }
      this.updateTotal()
    },
    addNewAddOnInItemForm() {
      this.addOn.subtotal = this.addOn.price
      this.addOn.qty = 1
      this.addOn.item = 'ADD999-ON'
      this.addOn.note = `${this.addOn.name} - ${this.addOn.note}`
      this.addOn.itemTitle = {
        product: this.addOn.name,
        value: this.additionalID,
      }

      this.invoiceData.items.push(JSON.parse(JSON.stringify(this.addOn)))

      // reset itemNew
      this.addOn = {
        name: null,
        price: 0,
        note: '',
        item: null,
        prices: [],
        subtotal: 0,
        qty: 0,
        discount: 0,
        unit: 'PCS',
        finishing: '',
        file: '',
        p: 1,
        l: 1,
        editable_price: false,
        is_stock: true,
      }

      const total = this.invoiceData.items.reduce((acc, item) => acc + (item.p * item.l * item.qty * item.price - item.discount), 0)
      this.invoiceData.total = total

      if (total - this.invoiceData.disc_exp < 0) {
        this.invoiceData.grand_total = 0
        this.invoiceData.disc_exp = total
      } else {
        this.invoiceData.grand_total = total - this.invoiceData.disc_exp
      }
    },
    removeItem(index) {
      this.invoiceData.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
      this.updateTotal()
    },
    initTrHeight() {
      // this.trSetHeight(null)
      // this.$nextTick(() => {
      //   this.trSetHeight(this.$refs.form.scrollHeight)
      // })
    },
    handleSubmit() {
      let error = false

      // CHECK CUSTOMER
      if (!this.invoiceData.customer) {
        this.$bvToast.toast('Pilih Customer terlebih dahulu!', {
          title: 'Warning',
          variant: 'warning',
          solid: true,
        })

        error = true
      }

      // MUST HAVE ITEMS
      if (!this.invoiceData.items.length) {
        this.$bvToast.toast('Tambahkan Item terlebih dahulu!', {
          title: 'Warning',
          variant: 'warning',
          solid: true,
        })

        error = true
      }

      // CHECK ITEM VALIDATION
      this.invoiceData.items.forEach(item => {
        if (!item.price || item.price <= 0) {
          this.$bvToast.toast('Harga Item tidak boleh kosong!', {
            title: 'Warning',
            variant: 'warning',
            solid: true,
          })

          error = true
        }

        if (item.qty <= 0) {
          this.$bvToast.toast('Qty harus lebih dari 0!', {
            title: 'Warning',
            variant: 'warning',
            solid: true,
          })

          error = true
        }
      })

      if (!error) {
        this.$http.put('/cashier/update', this.invoiceData)
          .then(() => {
            this.$bvToast.toast('Data Berhasil Diperbarui!', {
              title: 'Success',
              variant: 'success',
              solid: true,
            })
            this.$router.push({ name: 'toko-sales-list' })
          })
          .catch(() => {
            this.$bvToast.toast('Data Gagal Diperbarui!', {
              title: 'Error',
              variant: 'danger',
              solid: true,
            })
          })
      }
    },
    handlePS() {
      let error = false

      // CHECK CUSTOMER
      if (!this.invoiceData.customer) {
        this.$bvToast.toast('Pilih Customer terlebih dahulu!', {
          title: 'Warning',
          variant: 'warning',
          solid: true,
        })

        error = true
      }

      // MUST HAVE ITEMS
      if (!this.invoiceData.items.length) {
        this.$bvToast.toast('Tambahkan Item terlebih dahulu!', {
          title: 'Warning',
          variant: 'warning',
          solid: true,
        })

        error = true
      }

      // CHECK ITEM VALIDATION
      this.invoiceData.items.forEach(item => {
        if (!item.price || item.price <= 0) {
          this.$bvToast.toast('Item tidak boleh kosong!', {
            title: 'Warning',
            variant: 'warning',
            solid: true,
          })

          error = true
        }

        if (item.qty <= 0) {
          this.$bvToast.toast('Qty harus lebih dari 0!', {
            title: 'Warning',
            variant: 'warning',
            solid: true,
          })

          error = true
        }
      })

      if (!error) {
        this.$http.post('/cashier/presale', this.invoiceData)
          .then(() => {
            this.$bvToast.toast('Data Berhasil Disimpan!', {
              title: 'Success',
              variant: 'success',
              solid: true,
            })
            this.$router.push({ name: 'toko-presales-list' })
          })
          .catch(() => {
            this.$bvToast.toast('Data Gagal Disimpan!', {
              title: 'Error',
              variant: 'danger',
              solid: true,
            })
          })
      }
    },
    handleCustomerSubmit(customer) {
      this.$http.post('/customer/add', customer)
        .then(res => {
          this.$bvToast.toast('Data Customer Berhasil Dipilih!', {
            title: 'Success',
            variant: 'success',
            solid: true,
          })

          const savedCustomer = res.data.customer
          this.invoiceData.customer = {
            value: savedCustomer.id,
            customer: savedCustomer.name,
            raw: savedCustomer,
          }

          this.refreshCustomer()
        })
        .catch(() => {
          this.$bvToast.toast('Data Gagal Diproses! Masukan No HP dan Nama', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    handleEditAccess() {
      if (!this.editAccess.username || !this.editAccess.password) {
        this.$bvToast.toast('Username dan Password tidak boleh kosong!', {
          title: 'Warning',
          variant: 'warning',
          solid: true,
        })
        return
      }

      this.$http.post('cahier/price-edit-request', { username: this.editAccess.username, password: this.editAccess.password })
        .then(() => {
          this.itemNew.editable_price = true
          this.$bvModal.hide('modal-request-price')
          this.$bvToast.toast('Akses harga berhasil dibuka!', {
            title: 'Success',
            variant: 'success',
            solid: true,
          })

          this.editAccess.username = null
          this.editAccess.password = null
        })
        .catch(() => {
          this.$bvToast.toast('Otentikasi Akses Salah!', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
  setup() {
    const INVOICE_APP_STORE_MODULE_NAME = 'app-sales'
    const instance = getCurrentInstance()
    const proxy = instance && instance.proxy

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })

    const predictivePoNo = `SO${new Date().toISOString().slice(2, 10).replace(/-/g, '')}XXX`

    const paidTypeOpt = [
      { text: 'Bayar Sekarang', value: '1' },
      { text: 'Bayar Nanti', value: '2' },
      { text: 'Deposit Pelanggan', value: '3' },
    ]

    // MEMBER HANDLE
    const isMember = ref(0)

    const customerOpt = ref([])
    const customer = ref()
    const customerOptL = ref(false)
    const custSearch = ref('')

    const refreshCustomer = async () => {
      store.dispatch('app-sales/fetchCustomers', { q: custSearch.value })
        .then(response => {
          customerOptL.value = true
          customerOpt.value = response.data.data.data.map(cus => ({
            value: cus.id,
            customer: cus.name,
            raw: cus,
          }))
        }).finally(() => {
          customerOptL.value = false
        })
    }

    const customerOptS = search => {
      if (!search || search.length < 2) return
      custSearch.value = search
      refreshCustomer()
    }

    refreshCustomer()

    const itemNew = ref({
      item: null,
      price: 0,
      prices: [],
      qty: 0,
      discount: 0,
      unit: 'PCS',
      finishing: '',
      file: '',
      note: '',
      p: 1,
      l: 1,
      editable_price: false,
      is_stock: true,
    })

    const addOn = ref({
      name: '',
      cost_price: '',
      price: 0,
      note: '',
      item: null,
      qty: 0,
      discount: 0,
      unit: 'PCS',
      finishing: '',
      file: '',
      p: 1,
      l: 1,
      editable_price: false,
      is_stock: true,
    })

    const invoiceData = ref({
      customer: null, // mandatory
      toko: {},

      // ? Set single Item in form for adding data
      items: [],

      salesPerson: '',
      description: '',
      grand_total: 0,
      total: 0,
      disc_exp: 0,
      trx_date: new Date().toISOString().slice(0, 10),
      total_paid: 0,
      payment_due: null,
      cash_id: null,
      shipping_id: {
        value: 1,
        shipping: 'AMBIL DI TOKO',
      },
      paidType: '2', // mandatory
      so_addresses: {
        name: '',
        phone: '',
        email: '',
        address_line1: '',
        postal_code: '',
        province: '',
        city: '',
        subdistrict: '',
        village: '',
      },
    })

    const updateTotal = () => {
      invoiceData.value.items.forEach(item => {
        // Cari harga yang sesuai berdasarkan qty
        const applicablePrices = item.prices
          .filter(p => item.qty >= p.min_sales && p.member_status === isMember.value)
          .sort((a, b) => b.min_sales - a.min_sales) // ambil yang paling besar min_sales yang masih memenuhi

        if (applicablePrices.length > 0) {
          if (!item.editable_price) {
            // eslint-disable-next-line no-param-reassign
            item.price = applicablePrices[0].price
            // eslint-disable-next-line no-param-reassign
            item.subtotal = item.p * item.l * item.qty * item.price - item.discount
          }
        } else {
          proxy.$bvToast.toast('Harga tidak ditemukan untuk item ini!', {
            title: 'Peringatan',
            variant: 'warning',
            solid: true,
          })
          // eslint-disable-next-line no-param-reassign
          item.price = 0
          // eslint-disable-next-line no-param-reassign
          item.subtotal = 0
        }

        // Optional: kalau nggak ada yang cocok, bisa biarkan harga tetap atau kasih default
      })

      const total = invoiceData.value.items.reduce((acc, item) => acc + (item.p * item.l * item.qty * item.price - item.discount), 0)

      invoiceData.value.total = total

      if (total - invoiceData.value.disc_exp < 0) {
        invoiceData.value.grand_total = 0
        invoiceData.value.disc_exp = total
      } else {
        invoiceData.value.grand_total = total - invoiceData.value.disc_exp
      }
    }

    const updateTotalNew = () => {
      // Cari harga yang sesuai berdasarkan qty
      const applicablePrices = itemNew.value.prices
        .filter(p => itemNew.value.qty >= p.min_sales && p.member_status === isMember.value)
        .sort((a, b) => b.min_sales - a.min_sales) // ambil yang paling besar min_sales yang masih memenuhi

      if (applicablePrices.length > 0) {
        // eslint-disable-next-line no-param-reassign
        itemNew.value.price = applicablePrices[0].price
      } else {
        proxy.$bvToast.toast('Harga tidak ditemukan untuk item ini!', {
          title: 'Peringatan',
          variant: 'warning',
          solid: true,
        })
        // eslint-disable-next-line no-param-reassign
        itemNew.value.price = 0
      }
    }

    const updateDiscountHeader = () => {
      const discountHeader = invoiceData.value.disc_exp
      invoiceData.value.disc_exp = discountHeader
      updateTotal()
    }

    const itemsOptions = ref([])
    const additionalID = ref(null)
    store.dispatch('app-sales/fetchProducts')
      .then(response => {
        // eslint-disable-next-line array-callback-return, consistent-return
        itemsOptions.value = response.data.map(product => {
          let basePrice = 0
          product.prices.forEach(price => {
            // eslint-disable-next-line eqeqeq
            if (price.min_sales == 1) {
              basePrice = price.price
            }
          })
          if (product.sku === 'ADD999-ON') {
            additionalID.value = product.id
          } else {
            return {
              value: product.id,
              product: product.name,
              price: basePrice,
              qty: 1,
              note: '',
              is_stock: (product.is_stock === 1),
              is_dimension: (product.is_dimension === 1),
              p: 1,
              l: 1,
              prices: product.prices,
              unit: product.unit ? product.unit.name : '',
              editable_price: (product.editable_price === 1),
            }
          }
        })
      })

    const cashOpt = ref([])
    store.dispatch('app-sales/fetchCash')
      .then(response => {
        cashOpt.value = response.data.data.map(cash => ({
          value: cash.id,
          cash: cash.name,
        }))
      })

    const shippingOpt = ref([])
    store.dispatch('app-sales/fetchShipping')
      .then(response => {
        shippingOpt.value = response.data.shipping.map(shipping => ({
          value: shipping.id,
          shipping: shipping.name,
        }))
      })

    const updateItemForm = val => {
      const {
        qty, note, is_stock, editable_price, p, l, prices, is_dimension,
      } = val
      itemNew.value.qty = qty
      itemNew.value.note = note
      // eslint-disable-next-line camelcase
      itemNew.value.is_stock = is_stock
      // eslint-disable-next-line camelcase
      itemNew.value.is_dimension = is_dimension
      itemNew.value.p = p
      itemNew.value.l = l
      // eslint-disable-next-line camelcase
      itemNew.value.editable_price = editable_price
      itemNew.value.prices = prices

      updateTotalNew()
    }

    const updateItemPriceQty = () => {
      updateTotalNew()
    }

    const updateIsMember = val => {
      isMember.value = val
      updateTotal()
    }

    const route = proxy.$route
    const { id } = route.params
    store.dispatch('app-sales/fetchSales', id)
      .then(res => {
        const sales = res.data

        invoiceData.value.salesPerson = sales.pic
        invoiceData.value.id = sales.id

        invoiceData.value.customer = {
          value: sales.customer.id,
          customer: sales.customer.name,
          raw: sales.customer,
        }

        invoiceData.value.trx_date = sales.trx_date
        invoiceData.value.description = sales.desc
        invoiceData.value.grand_total = sales.grand_total
        invoiceData.value.total = sales.total
        invoiceData.value.disc_exp = sales.disc_exp
        invoiceData.value.payment_due = sales.payment_due

        if (sales.adresses) {
          invoiceData.value.so_addresses = {
            name: sales.addresses.recipient_name,
            phone: sales.addresses.phone,
            address_line1: sales.addresses.address_line1,
            postal_code: sales.addresses.postal_code,
            province: sales.addresses.province,
            city: sales.addresses.city,
            subdistrict: sales.addresses.subdistrict,
            village: sales.addresses.village,
          }
        }

        if (sales.shipping !== 1 && sales.shipping !== null) {
          invoiceData.value.shipping_id = {
            value: sales.shipping.id,
            shipping: sales.shipping.name,
          }
        }

        console.log('Before update', invoiceData.value.items)
        invoiceData.value.items = sales.details.map(item => {
          console.log(item)
          return {
            itemTitle: {
              value: item.product.id,
              product: item.product.name,
            },
            price: item.price,
            subtotal: item.subtotal,
            discount: (item.price * item.l * item.p * item.qty) - item.subtotal,
            prices: item.product.prices,
            qty: parseInt(item.qty, 10),
            note: item.desc,
            p: parseInt(item.p, 10),
            l: parseInt(item.l, 10),
            finishing: item.finishing,
            file: item.file,
            editable_price: item.product.editable_price,
            is_stock: item.product.is_stock,
            is_dimension: item.product.is_dimension,
          }
        })
        console.log('After update', invoiceData.value.items)
      })
      .catch(error => {
        console.error('Gagal ambil data sales:', error)
      })

    store.dispatch('app-sales/fetchCompany')
      .then(comp => {
        invoiceData.value.toko = comp.data.data
      })
      .catch(error => {
        console.error('Gagal ambil data produk:', error)
      })

    return {
      invoiceData,
      customerOpt,
      customerOptS,
      customerOptL,
      custSearch,
      shippingOpt,
      customer,
      refreshCustomer,
      cashOpt,
      paidTypeOpt,
      itemsOptions,
      updateItemForm,
      updateItemPriceQty,
      updateDiscountHeader,
      updateTotal,
      updateTotalNew,
      itemNew,
      addOn,
      additionalID,
      predictivePoNo,
      isMember,
      updateIsMember,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
      color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import '~@core/scss/base/components/variables-dark';

.logo-wrapper {
  max-width: 10px; /* sesuaikan ukurannya */
  height: auto;
}

.logo-wrapper > * {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.form-item-section {
background-color:$product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  // overflow: hidden;
  transition: .35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }

  }
}
</style>
